import { DATA_DELIM, VISA_SRCI_IFRAME_ID } from '../constants/common';
import collapsedLogger from './collapsed-logger';
import getDomain from './get-domain';
import isWindow from './is-window';
import logger from './logger';
import OrchCustomData from './orch-custom-data';
import postMessageToIframe from './post-message-to-iframe';

const sendMessageToVisaSrci = (eventId, data = {}) => {
  logger('Postmessage: eventId:', eventId);
  collapsedLogger('Postmessage: data:', data);
  const message = `${eventId}${DATA_DELIM}${JSON.stringify(data)}`;
  const windowRef = OrchCustomData.srcSdks?.orchConfig?.windowReference ?? null;
  if (windowRef) {
    const windowParam = isWindow(windowRef) ? windowRef : null;

    postMessageToIframe(message, VISA_SRCI_IFRAME_ID, getDomain(), windowParam);
  }
};

export default sendMessageToVisaSrci;
